import { authJsonHeaders } from './authHeaders';

function getStoredUsername() {
  try {
    const raw = localStorage.getItem('user') || sessionStorage.getItem('user');
    const user = raw ? JSON.parse(raw) : null;
    if (user?.username) return String(user.username);
  } catch (_) {
    /* ignore */
  }
  return 'Inconnu';
}

function buildPeriodLabel({ filterType, date, dateDebut, dateFin, mois, annee }) {
  if (filterType === 'jour' && date) return `jour ${date}`;
  if (filterType === 'periode' && dateDebut && dateFin) return `période ${dateDebut} → ${dateFin}`;
  if (filterType === 'mois' && mois && annee) {
    return `mois ${String(mois).padStart(2, '0')}/${annee}`;
  }
  if (filterType === 'annee' && annee) return `année ${annee}`;
  return '';
}

/**
 * Enregistre l'impression État CGM (print_history + traçabilité via API).
 * Ne bloque pas l'ouverture de l'impression en cas d'erreur.
 */
export async function recordEtatCgmPrint(period = {}) {
  const periodLabel = buildPeriodLabel(period);
  const body = {
    client_id: null,
    client_nom: 'Bureau',
    client_prenom: 'Général',
    montant: 0,
    caissier_username: getStoredUsername(),
    type_reçu: 'etat_cgm',
    libelle: periodLabel ? `État CGM — ${periodLabel}` : 'État CGM',
  };

  try {
    await fetch('/api/print-history', {
      method: 'POST',
      headers: authJsonHeaders(),
      body: JSON.stringify(body),
    });
  } catch (err) {
    console.warn('Traçabilité impression état CGM:', err);
  }
}
